import {GET_REQUESTS_RESCHEDULE} from "../../../enums/Request/request.types";

export const getRequestsForRescheduleAction = (requests) => {
    return {
        type: GET_REQUESTS_RESCHEDULE,
        payload: requests,
    };
};
